import React, { useState, useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useData } from '../../contexts/DataContext';
import OnboardingModal from './OnboardingModal';

// No mostramos el modal en estas rutas: el usuario está autenticando o
// ejecutando una acción crítica. Volverá a aparecer en la próxima ruta.
const SUPPRESS_PATHS = [
  '/user-authentication',
  '/login',
  '/register',
  '/oauth-callback',
  '/legal',
  '/checkout',
];

/**
 * Decide cuándo mostrar el OnboardingModal:
 *  - User autenticado.
 *  - user.onboarding_completed === false.
 *  - Ruta no está en SUPPRESS_PATHS.
 *
 * Vive dentro de DataProvider para tener acceso a `useData()`. Se monta
 * una sola vez por sesión (cierre del modal queda persistido en backend).
 */
const OnboardingHost = () => {
  const { user, fetchUser } = useData();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => { setDismissed(false); }, [user?.id]);

  if (!user || !user.id) return null;
  if (user.onboarding_completed) return null;
  if (dismissed) return null;
  if (SUPPRESS_PATHS.some(p => location.pathname === p || location.pathname.startsWith(p + '/'))) return null;

  // Si el user llegó con ?intent=... (ej. desde la CTA "Asociarme a mi
  // empresa" del landing), el modal salta la selección y va directo al
  // tour del rol correspondiente. Elimina fricción de re-elegir intent.
  const initialIntent = searchParams.get('intent');

  return (
    <OnboardingModal
      user={user}
      initialIntent={initialIntent}
      onComplete={() => {
        setDismissed(true);
        // Refrescar el user del context para que el flag completed quede
        // sincronizado y el modal no vuelva a abrirse al cambiar de ruta.
        fetchUser?.(true);
      }}
    />
  );
};

export default OnboardingHost;
